export default __webpack_public_path__ + "static/media/icons-system-edit-circle-large.98a71828.svg";